// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__3keqI","col":"styles_col__2-9We","fulfillmentStatus":"styles_fulfillmentStatus__27FHU","emailCol":"styles_emailCol__3f7hb"};